export const orderAddressRequest = ({
    addressLine,
    commune,
    district,
    province,
    country,
} = {}) => ({
    addressLine,
    commune,
    district,
    province,
    country,
});